import * as styles from "./FieldContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useFieldContext } from "./Field.context";
import type { FieldContentProps } from "./Field.types";

export function FieldContent({
  className,
  ...props
}: FieldContentProps): JSX.Element {
  const { orientation } = useFieldContext();

  return (
    <div
      data-slot="field-content"
      className={clsx(styles.content({ orientation }), className)}
      {...props}
    />
  );
}
